import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { I as IconButton } from '../../Button/IconButton/IconButton-Copc-LdF.js';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const PageNavButton = withTaktFallbackId(IconButton);
const PaginationButton = ({
  id,
  ariaLabel,
  onClick,
  icon,
  disabled = false,
  size = 'base',
  taktId,
  taktValue,
  taktFallbackId,
  ...rest
}) => /*#__PURE__*/React__default.createElement(PageNavButton, _extends({}, rest, {
  id: id,
  icon: icon,
  onClick: onClick,
  label: ariaLabel,
  disabled: disabled,
  small: size === 'small',
  taktId: taktId,
  taktValue: taktValue,
  taktFallbackId: taktFallbackId
}));

export { PaginationButton as P };
//# sourceMappingURL=PaginationButton-BjfiewnO.js.map
